import type {
	TotalActionsPerOrganizationItem,
	TotalActionsPerOrganizationTriggerItem,
} from '@/app/types/Dashboard';

import { roundPercentagesToTotal } from '@/app/utils/number';

const defaultOptions: Highcharts.Options = {
	credits: {
		enabled: false,
	},
	chart: {
		type: 'pie',
		plotBackgroundColor: undefined,
		plotBorderWidth: 0,
		plotShadow: false,

		margin: 0,
		borderRadius: 0,
		height: 100,
		width: 100,
	},
	title: {
		text: '',
		align: 'center',
		verticalAlign: 'middle',
		x: 0,
		style: {
			padding: '0px',
			margin: '0px',
			color: '#18c096',
			fontFamily: 'Graphik-Semibold',
			fontSize: '25px',
			backgroundColor: 'blue',
			background: 'blue',
		},
	},
	tooltip: {
		pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b>',
		enabled: false,
	},
	accessibility: {
		point: {
			valueSuffix: '%',
		},
		enabled: false,
	},
	legend: {
		align: 'left',
		layout: 'vertical',
		enabled: false,
		useHTML: true,
		squareSymbol: false,
		symbolWidth: 0,
		symbolRadius: 0,
	},
	plotOptions: {
		pie: {
			borderWidth: 0,
			dataLabels: {
				enabled: true,
				distance: 0,
				style: {
					fontWeight: 'bold',
					color: 'white',
				},
			},
			center: ['50%', '50%'],
			size: 100,
			enableMouseTracking: false,
		},
	},
	series: [],
};

const getTotalPercentage = (items: TotalActionsPerOrganizationTriggerItem[]) => {
	return items.reduce((acc, item) => {
		return acc + parseInt(item.percentage);
	}, 0);
};

export const Chart = {
	toActionDistributionOptions: (data: TotalActionsPerOrganizationItem) => {
		// get total percentage from trioggeredData

		const total = getTotalPercentage(data?.triggeredData ?? []);
		const totalExternal = getTotalPercentage(
			data.triggeredData?.filter((item) => item.isExternal === true) ?? []
		);
		const totalInternal = getTotalPercentage(
			data.triggeredData?.filter((item) => item.isExternal === false) ?? []
		);

		const rounded = roundPercentagesToTotal([
			totalExternal / total || 0,
			totalInternal / total || 0,
		]);
		return {
			...defaultOptions,
			series: [
				{
					type: 'pie',
					data: [
						{
							name: 'Customers',
							y: Math.round(rounded[0]),
							dataLabels: {
								enabled: false,
							},
							color: '#0cc7d7',
						},
						{
							name: 'Staff',
							y: Math.round(rounded[1]),
							dataLabels: {
								enabled: false,
							},
							color: '#5547eb',
						},
					],
				},
			],
		};
	},
};
